import { API_AUTH } from "./common";

const TrichLapApi = {
  PhanQuyen: () =>
    API_AUTH.get(`thu-chi-trich-lap/phan-quyen-thu-chi-trich-lap`, {}),
  DanhSach: (search, pageIndex, pageSize) =>
    API_AUTH.get(
      `thu-chi-trich-lap/danh-sach?search=${search}&pageIndex=${pageIndex}&pageSize=${pageSize}`
    ),
};

export default TrichLapApi;
